import React from 'react';
import * as FiIcons from 'react-icons/fi';
import { FiAlertTriangle } from 'react-icons/fi';

/**
 * SafeIcon Component
 * Responsibility: Prevents UI crashes by catching missing icon references.
 * Optimized for react-icons/fi library.
 */
const SafeIcon = ({ icon, name, className, ...props }) => {
  // 1. Prioritize direct component pass
  if (icon) {
    const IconComponent = icon;
    return <IconComponent className={className} {...props} />;
  }

  // 2. Fallback to name-based lookup
  if (name) {
    const iconKey = name.startsWith('Fi') ? name : `Fi${name}`;
    const NamedIcon = FiIcons[iconKey];
    if (NamedIcon) {
      return <NamedIcon className={className} {...props} />;
    }
  }

  // 3. Final safety fallback
  return <FiAlertTriangle className={className || "text-amber-500"} {...props} />;
};

export default SafeIcon;